<div class="mainContent">

    <div style="height: 12vh;">
        <div>
            <label i18n="@@spmsUserReg" class="textColour"
                [ngStyle]="{'border-color':buttonColor}">Delete Objects From
                Target</label>
            <span class="example-spacer"></span>
        </div>
    </div>
    <div>

        <div style="height: 25vh; margin-left: 15%;">
            <form novalidate [formGroup]='FormValid'>
                <div class="row">
                    <div class="col-lg-4">
                        <mat-form-field appearance="outline">
                            <mat-label
                                i18n="@@TMshoppingcomplexchooseimage">
                                Select Parent Object</mat-label>
                            <mat-select formControlName="object">
                                <mat-option>None</mat-option>
                                <mat-option *ngFor="let field of objectsList"
                                    [(value)]="field.objectname">
                                    {{field.objectlabel}}
                                </mat-option>
                            </mat-select>
                            <!-- 
                            Modified by Ashwin M 
                            08/07/2024
                            code modified to add validation messages for
                            object level deletion
                            -->
                            <mat-error
                                *ngFor="let validation of validationMessages.object">
                                <span
                                    *ngIf="FormValid.get('object').hasError(validation.type) 
                                    && (FormValid.get('object').dirty || 
                                    FormValid.get('object').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4">
                        <div style="display: flex; width: max-content;">
                            <mat-form-field appearance="outline">
                                <!-- 
                                Modified by Ashwin M 
                                08/07/2024
                                code modified to indicate CSV file upload in label
                                -->
                                <mat-label
                                    i18n="@@TMshoppingcomplexchooseimage">Choose
                                    Parent Ids File(CSV)</mat-label>
                                <input matInput class="file-path validate"
                                    type="text" maxlength="250"
                                    placeholder="Choose Parent Id's File"
                                    formControlName="imageName" id="imageName"
                                    [(ngModel)]="statevaluechange.fileName"
                                    readonly>
                                <!-- 
                                Modified by Ashwin M 
                                08/07/2024
                                code modified to add validation messages for
                                object level deletion
                                -->
                                <mat-error
                                    *ngFor="let validation of validationMessages.imageName">
                                    <span
                                        *ngIf="FormValid.get('imageName').hasError(validation.type) 
                                            && (FormValid.get('imageName').dirty || 
                                            FormValid.get('imageName').touched)">
                                        {{ validation.message }}
                                    </span>
                                </mat-error>
                            </mat-form-field>
                            <div class="file-field"
                                style="width: 20%; margin-left: 1rem;">
                                <a class="btn-floating btn-sm m-0 float-right">
                                    <em class="fas fa-paperclip mt-0"
                                        style="text-rendering: auto;color:black"></em>
                                    <input type="file" id="imageupload"
                                        name="imageupload"
                                        (change)="imagePhotofunction($event,'csv')"
                                        formControlName="imageupload">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

    </div>

    <div style="height:3vh">
        <div class="row mb-1 topRowMargins"
            style="position:sticky;left:0;bottom:0;width:100%">
            <div class="col-lg-5"></div>
            <div class="col-lg-7">

                <div style="text-align: end;margin-left: 10%">
                    <button i18n="@@TargetCancel" type="button"
                        (click)="closeFunction()"
                        class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                        style="padding: .3rem 1.6rem;font-size: .85rem;"
                        [style.border-color]="buttonColor">
                        Cancel
                    </button>
                    <button i18n="@@TMRunButton" type="button"
                        (click)="initateDeletion()"
                        [style.background-color]="buttonColor"
                        class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize">
                        Initiate Deletion
                    </button>

                </div>
            </div>
        </div>

    </div>
</div>
